import React from 'react';
import { connect } from 'react-redux';
import { deleteReportnotif } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deleteReportnotif,
};

function ModalDeleteItem({ data, deleteReportnotif, closeModal }) {
  const auth = data?.auth;
  const history = data?.history;
  const item = data?.item;
  const id = item?.id;
  const screenWidth = useScreenWidth();

  function handleDelete() {
    deleteReportnotif({ auth, history, id });
    closeModal();
  }

  return (
    <Modal
      variant='danger'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1'>
        Apakah Anda yakin ingin menghapus{' '}
        <span className='has-text-danger has-text-weight-semibold'>laporan absensi kelas {item.kelas}</span>{' '}
        ?
      </p>
      <div className='flex justify-end align-center pt-2'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteItem);
